import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortByIndexPipe } from './sort-by-index.pipe';

@NgModule({
  declarations: [SortByIndexPipe],
  imports: [CommonModule],
  exports: [SortByIndexPipe],
})
export class SortByIndexModule {}
